/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_X15_Not_MemberInputs */



/**
* | output |
* | --- |
* | "No team account uses that Google address. Sign in with your work email, or ask an admin to invite that address." |
*
* @param {Auth_X15_Not_MemberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_x15_not_member = /** @type {((inputs?: Auth_X15_Not_MemberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_X15_Not_MemberInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("No team account uses that Google address. Sign in with your work email, or ask an admin to invite that address.")
});